import { VIOLET_700 } from '../../styles/colors';
import { INTER } from '../../styles/fonts';
import styled from 'styled-components';

export const SuccessIcon = () => {
  return (
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 23L20.6667 27.6667L30 18.3333M44 23C44 34.598 34.598 44 23 44C11.402 44 2 34.598 2 23C2 11.402 11.402 2 23 2C34.598 2 44 11.402 44 23Z" stroke="url(#paint0_linear_13798_2477)" strokeWidth="3.3" strokeLinecap="round" strokeLinejoin="round"/>
      <defs>
        <linearGradient id="paint0_linear_13798_2477" x1="-3.13158" y1="7.28947" x2="44" y2="38.3947" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3452FF"/>
          <stop offset="0.56285" stopColor="#AA06E4"/>
          <stop offset="1" stopColor="#E7282D"/>
        </linearGradient>
      </defs>
    </svg>
  )
}

// Styled Components
export const ModalBackdrop = (styled.div as any)<{ $visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: ${(props: { $visible: boolean }) => props.$visible ? 1 : 0};
  visibility: ${(props: { $visible: boolean }) => props.$visible ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

export const ModalContainer = (styled.div as any)<{ $visible: boolean }>`
  background-color: rgba(243, 244, 247, 0.8);
  margin: 0 88px;
  border-radius: 12px;
  overflow: hidden;
  padding: 3vh 5vw;
  transform: ${(props: { $visible: boolean }) => props.$visible ? 'scale(1)' : 'scale(0.9)'};
  transition: transform 0.3s ease;
`;

export const ModalContent = styled.div`
  border-radius: 12px;
  gap: 3vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MessageText = styled.span`
  font-family: ${INTER.regular};
  color: ${VIOLET_700};
  font-size: 13px;
  text-align: center;
  margin: 0 0;
  /* Make text not selectable/copiable */
  user-select: none;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  pointer-events: none; /* Additional protection */
`;
